import { createReducer } from 'reduxsauce'
import { configDuckList } from '~/store/config'

export const { 
  Connector, 
  Route, 
  Types, 
  Creators 
} = configDuckList("@Notices", { Connector: "News_1", Route: "notices" });

const INITIAL_STATE = {
  loading: false,
  success: false,
  error: false,
  result: [],
  page_count: 0,
  current_page: 0
}

const getNoticesRequest = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
  success: false
})

const getNoticesSuccess = (state = INITIAL_STATE, { 
  data : { 
    result, 
    page_count, 
    current_page, 
    isLazy 
  } 
}) => ({
  ...state,
  result: isLazy ? [...state.result, ...result] : result,
  page_count,
  current_page,
  loading: false,
  success: true,
})

export default createReducer(INITIAL_STATE, {
  [Types.GET_REQUEST]: getNoticesRequest,
  [Types.GET_SUCCESS]: getNoticesSuccess,
})